import React from "react";
import { MapPin, Clock, Phone, Navigation, Wrench, ShoppingBag } from "lucide-react";
import { Button } from "@/components/ui/button";

const ADDRESS = "G-189, Funtasiya Business Park, Plot no. 47, Sector 30A, Vashi, Navi Mumbai, Maharashtra 400703";

export default function PhysicalStoreCard() {
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;
  return (
    <section id="store" className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <div className="rounded-3xl border border-border overflow-hidden grid md:grid-cols-2 bg-card">
        <div className="p-8 sm:p-10 relative">
          <span className="tv-chip-emerald mb-4">
            <MapPin className="w-3.5 h-3.5" /> Visit In-Store
          </span>
          <div className="flex items-center gap-4 mb-4">
            <img src="/tech-value-logo.png" alt="Tech World logo" className="w-16 h-16 object-contain shrink-0" />
            <div>
              <div className="font-brand text-3xl sm:text-4xl font-extrabold tracking-tighter text-foreground leading-none">Tech World</div>
              <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground mt-1">Mobile & Laptop · Vashi</div>
            </div>
          </div>
          <p className="text-muted-foreground leading-relaxed">
            Prefer to walk-in? Bring your device to our physical <span className="font-semibold text-foreground">Tech World</span> counter —
            certified inspection, spot cash payout, plus free data-wipe demo & 3-month warranty on refurbished purchases.
          </p>

          <div className="mt-5 flex flex-wrap gap-3 text-xs">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary px-3 py-1.5 font-semibold">
              <Wrench className="w-3.5 h-3.5" /> Mobile & Laptop Repair
            </span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary px-3 py-1.5 font-semibold">
              <ShoppingBag className="w-3.5 h-3.5" /> Refurbished Sales
            </span>
          </div>

          <div className="mt-6 space-y-4">
            <div className="flex gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-500/15 text-amber-600 flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Address</div>
                <div className="text-sm font-medium leading-relaxed" data-testid="store-address">{ADDRESS}</div>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-500/15 text-amber-600 flex items-center justify-center shrink-0">
                <Clock className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Timings</div>
                <div className="text-sm font-medium">10:30 AM – 8:00 PM · Mon–Sat · Sunday Closed</div>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-10 h-10 rounded-xl bg-amber-500/15 text-amber-600 flex items-center justify-center shrink-0">
                <Phone className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Contact</div>
                <div className="text-sm font-medium">+91 81048 78405 · +91 73037 57443</div>
              </div>
            </div>
          </div>

          <a href={mapsUrl} target="_blank" rel="noreferrer" className="inline-block mt-6" data-testid="store-directions-link">
            <Button className="bg-gradient-to-r from-amber-500 to-amber-600 hover:opacity-90 text-white">
              <Navigation className="w-4 h-4 mr-2" /> Get Directions on Google Maps
            </Button>
          </a>
        </div>

        <div className="relative min-h-[300px] bg-gradient-to-br from-amber-50 via-slate-50 to-emerald-50 dark:from-amber-950/20 dark:via-slate-900 dark:to-slate-800">
          <div className="absolute inset-0 tv-dot-bg opacity-40" />
          <iframe
            title="Tech World Store Location"
            width="100%"
            height="100%"
            style={{ border: 0, minHeight: 300 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`}
          />
        </div>
      </div>
    </section>
  );
}
